import * as React from 'react';
import { observer } from 'mobx-react';

import { SearchBox, initializeIcons } from 'office-ui-fabric-react';
import { Input, Label, Row, Col } from 'reactstrap';
import PersonStore from '@app/Stores/PersonStore';
import { SearchFilters } from '@app/AppConstants';
import { PersonList } from '@app/Components/PersonList';

initializeIcons();

type SidebarProps = {
    personStore: PersonStore;    
};

@observer
export class Sidebar extends React.Component<SidebarProps, {}> {
    
    private _personStore: PersonStore;
    
    constructor(props:SidebarProps){
        super(props);
        this._personStore = this.props.personStore;
    }
    
    render() {
        return (
            <div className="sidebar">
                <div className="sidebar-top">
                    <Row>
                        <Col>
                            <Label><Input type="checkbox" style={{verticalAlign:'middle'}} addon onChange={() => this._personStore.switchCheckbox(SearchFilters.firstName)} checked={this._personStore.isSearchedByFirstName}/> First name</Label>
                            <Label><Input type="checkbox" style={{verticalAlign:'middle'}} addon onChange={() => this._personStore.switchCheckbox(SearchFilters.lastName)} checked={this._personStore.isSearchedByLastName} /> Last name</Label>
                            <Label><Input type="checkbox" style={{verticalAlign:'middle'}} addon onChange={() => this._personStore.switchCheckbox(SearchFilters.exactMatch)} checked={this._personStore.isSearchedWithExactMatch}  /> Exact match </Label>
                            <Label><Input type="checkbox" style={{verticalAlign:'middle'}} addon onChange={() => this._personStore.switchCheckbox(SearchFilters.deletedInclude)} checked={this._personStore.isSearchedWithDeleted} /> With Deleted</Label>
                        </Col>
                        <Col>
                            <Label><Input type="checkbox" style={{verticalAlign:'middle'}} addon onChange={() => this._personStore.switchCheckbox(SearchFilters.code)} checked={this._personStore.isSearchedByCode}/> Code</Label>
                            <Label style={{width:'100%'}}><Input type="checkbox" style={{verticalAlign:'middle'}} addon onChange={() => this._personStore.switchCheckbox(SearchFilters.id)} checked={this._personStore.isSearchedById}/> Id</Label>
                            <Label><Input type="checkbox" style={{verticalAlign:'middle'}} addon onChange={() => this._personStore.switchCheckbox(SearchFilters.inactiveInclude)} checked={this._personStore.isSearchedWithInactive}/> With Inactive</Label>
                        </Col>
                    </Row>
                    
                    <SearchBox
                        className="sidebar-search"
                        placeholder="Search"
                        value={this._personStore.searchPersonString}
                        onChange={this._personStore.onSearchTermChanged}
                        underlined={true}
                    />
                </div>
                <div className="sidebar-list">
                    <div className="sidebar-list-container" data-is-scrollable={true}>
                        <PersonList 
                            personStore={this._personStore}
                            selectedPersonId={this._personStore.selectedPerson? this._personStore.selectedPerson.id : null}
                        />
                    </div>
                </div>
            </div>
        );
    }
}